import "./App.css";
import "./styles/custom.css";
import "./styles/fa.css";
import React, { lazy, useEffect, Suspense, useMemo } from "react";
import $ from "jquery";
import Topbar from "./components/component/Topbar";
import ScrollToTop from "./ScrollToTop";
import HelperScript from "./utils/helper";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ReactGA from "react-ga4";
import InjectScript from "./components/CustomScript";
import { marqueeFetchData } from "./redux/actions/marqueeAction";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { menuFetchData } from "./redux/actions/menuAction";
import { childmenuFetchData } from "./redux/actions/childmenuAction";
import { tithiFetchData } from "./redux/actions/tithiAction";
import { widgetFetchData } from "./redux/actions/widgetAction";
import { horoscopeFetchData } from "./redux/actions/horoscopeAction";
import { footerFetchData } from "./redux/actions/footerAction";
import { settingFetchData } from "./redux/actions/settingAction";
import { categoryAstroFetchData } from "./redux/actions/categoryAstroAction";
import { useDispatch, useSelector } from "react-redux";
import EventIndex from "./components/subcomponents/Event/EventIndex";
import AllEvents from "./components/subcomponents/Event/AllEvents";
import EventDetails from "./components/subcomponents/Event/EventDetails";
import EventBooking from "./components/subcomponents/Event/EventBooking";
import Bajaj from "./components/pages/Bajaj";
import WebStoryAll from "./components/subcomponents/WebStoryAll";
import WebStoryPage from "./components/subcomponents/WebStoryPage";
import BajajApp from "./components/pages/BajajApp";
import Status from "./components/subcomponents/Event/Statues";
import NewsSearch from "./components/pages/NewSearch";
import ScrollPage from "./components/subcomponents/abc";

import AstrologyDetailpage from "./components/subcomponents/astrologycomponent/AstrologyDetailpage";
import { menuTabsFetchData } from "./redux/actions/menuTabsActions";
import ComscoreTracker from "./ComscoreTracker";
import { addCategoryToCookie, setUserCookie } from "./utils/userCookie";
import Foryou from "./components/pages/Foryou";
import CandidateList from "./components/subcomponents/PdfPage";

import ElectionPage from "./components/subcomponents/election/ElectionPage";
import ElectionDetailpage from "./components/subcomponents/election/ElectionDetailpage";
import IndiaMap from "./components/subcomponents/election/Try";
import GujaratMap from "./components/subcomponents/election/Try";
import StatesRow from "./components/subcomponents/election/Try";
import RashifalPage from "./components/subcomponents/astrologycomponent/RashifalPage";
import LocalBodyEle from "./components/subcomponents/election/LocalBodyEle";
import AssemblyEle from "./components/subcomponents/election/AssemblyEle";

const Home = lazy(() => import("./components/pages/Home"));
const Menu = lazy(() => import("./components/subcomponents/Menu"));
const MenuPage = lazy(() => import("./components/subcomponents/MenuPage"));
const BreadCrumb = lazy(() => import("./components/component/BreadCrumb"));
const ScrollButton = lazy(() => import("./components/pages/ScrollButton"));
const Gujarat = lazy(() => import("./components/pages/Gujarat"));
const Rss = lazy(() => import("./components/pages/Rss"));
const Post = lazy(() => import("./components/pages/Post"));
const Sitemap = lazy(() => import("./components/pages/Sitemap"));
const Epaper = lazy(() => import("./components/pages/Epaper/Epaper"));
// jay Ganesha
// jay mataji
const ClippedImage = lazy(
  () => import("./components/pages/Epaper/ClippedImage"),
);
const EpaperCategoryNewsPerDate = lazy(
  () => import("./components/pages/Epaper/EpaperCategoryNewsPerDate"),
);
const Pages = lazy(() => import("./components/pages/Pages"));
const VideosComponent = lazy(
  () => import("./components/pages/VideosComponent"),
);
const PagesInvestorRelation = lazy(
  () => import("./components/pages/PagesInvestorRelation"),
);
const GalleryComponent = lazy(
  () => import("./components/pages/GalleryComponent"),
);
const AstrologyComponent = lazy(
  () => import("./components/pages/AstrologyComponent"),
);
const SearchResult = lazy(() => import("./components/pages/SearchResult"));
const Profile = lazy(() => import("./components/pages/Profile"));
const Maintenance = lazy(() => import("./components/pages/maintenance"));
const Supplement = lazy(() => import("./components/pages/Supplement"));
const VideoCategoryPage = lazy(
  () => import("./components/pages/VideoCategoryPage"),
);
const GujaratMetro = lazy(() => import("./components/pages/GujaratMetro"));
const GujaratSamagra = lazy(() => import("./components/pages/GujaratSamagra"));
const Sport = lazy(() => import("./components/pages/Sport"));
const AssemblyElection = lazy(
  () => import("./components/pages/AssemblyElection"),
);
const GaneshChaturthiPage = lazy(
  () => import("./components/pages/GaneshChaturthiPage"),
);
const Footer = lazy(() => import("./components/subcomponents/Footer"));

const EpaperMenu = lazy(() => import("./components/pages/Epaper/EpaperMenu"));

function App() {
  const [mode, setMode] = React.useState("light");
  const [url, setUrl] = React.useState(window.location.href);
  const [sport, setSport] = React.useState(false);
  // const [load, setLoad] = React.useState(false);
  // setTimeout(() => {
  //   setLoad(true);
  // }, [5000]);
  const { 50: sportLayout } = useSelector(
    (state) => state?.SettingReducer?.data,
  );
  const onDarkMode = () => {
    document.documentElement.classList.toggle("dark-mode");
    setMode(mode === "dark" ? "light" : "dark");
  };

  useEffect(() => {
    const path = window.location.pathname;
    const segments = path.split("/").filter(Boolean);

    // First slug = main category
    const mainCategory = segments[0];

    addCategoryToCookie(mainCategory);
  }, [window.location.pathname]);

  Sentry.init({
    dsn: "https://9fbd68e8996640c294f72b3d924bf7cf@o1158838.ingest.sentry.io/6242283",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  ReactGA.initialize("G-6YPHENN7FN", {
    titleCase: false,
  });
  useEffect(() => {
    const lang = localStorage.getItem("site_lang");
    if (lang) {
      document.cookie = `googtrans=/en/${lang};path=/`;
    }
  }, []);
  useEffect(() => {
    setInterval(() => {
      setUrl(window.location.href);
    }, 300);
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(settingFetchData());
    const timer = setTimeout(() => {
      dispatch(menuFetchData());
      dispatch(menuTabsFetchData());
      dispatch(childmenuFetchData());
      dispatch(tithiFetchData());
      dispatch(widgetFetchData());
      dispatch(footerFetchData());
      dispatch(horoscopeFetchData());
      dispatch(categoryAstroFetchData());
      dispatch(marqueeFetchData());
    }, 350);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const routeChange = () => { };
  useEffect(() => {
    if (window.location.pathname === "/llms.txt") {
      window.location.href = "/";
    }
  }, []);
  useEffect(() => {
    if (
      window.location.pathname ===
      "/gujarat/news/surat/the-problem-of-finding-the-right-market-in-surats-textile-market-and-its-digital-solution"
    ) {
      window.location.href =
        "/gujarat/news/business/surat/the-problem-of-finding-the-right-market-in-surats-textile-market-and-its-digital-solution";
    }
    if (
      window.location.pathname === "/webstory/" ||
      window.location.pathname === "/webstory"
    ) {
      window.location.replace("https://sandesh.com/webstories");
    }
  }, []);
  useEffect(() => {
    $("section.menu .nav-item a").each(function () {
      $(this).removeClass("act");
      if (window.location.pathname === $(this).attr("href")) {
        $(this).addClass("act");
      }
    });
    $(".navbar-toggler").addClass("collapsed").attr("aria-expanded", "false");
    $(".navbar-collapse").removeClass("show");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [window.location.href]);

  const taboolacontent =
    "" +
    "<script>" +
    "window._taboola = window._taboola || [];" +
    "_taboola.push({notify:'newPageLoad'});" +
    "_taboola.push({article:'auto', url: '" +
    window.location.href +
    "'});" +
    // "_taboola.push({category:'auto', url: '" + window.location.href + "'});" +
    // "_taboola.push({homepage:'auto', url: '" + window.location.href + "'});" +
    "</script>" +
    "";

  const headerMobile =
    "" +
    "<div id='div-gpt-ad-1646996478869-0' class='ad-placeholder' style='min-width: 300px; min-height: 100px;'>" +
    "<script>" +
    "window.googletag = window.googletag || { cmd: [] };" +
    "googletag.cmd.push(function () {" +
    "googletag.defineSlot('/22678428348/Mweb_Header_Global_300x100', [300, 100], 'div-gpt-ad-1646996478869-0').addService(googletag.pubads());" +
    "googletag.pubads().enableSingleRequest();" +
    "googletag.pubads().disableInitialLoad();" +
    "googletag.enableServices();" +
    "});" +
    "</script>" +
    "" +
    "<script>" +
    " googletag.cmd.push(function() { googletag.display('div-gpt-ad-1646996478869-0'); });" +
    "</script>" +
    "</div>" +
    // '<div id="gpt-passback">' +
    // "<script>" +
    // "window.googletag = window.googletag || {cmd: []};" +
    // "googletag.cmd.push(function() {" +
    // "googletag.defineSlot('/21928950349,22624158342/sandesh_backfill_300x100', [300, 100], 'gpt-passback').addService(googletag.pubads());" +
    // "googletag.enableServices();" +
    // "googletag.display('gpt-passback');" +
    // "});" +
    // "</script>" +
    // "</div>" +
    "" +
    "";

  const allPage =
    "" +
    '<div id="bsrv1338" data-domain="sandesh.com" data-click-tracker="%%CLICK_TRACKER%%">' +
    '<script src="https://bsrv.bidsxchange.com/1338.js"></script>' +
    "</div>" +
    '<script src="https://bsrv-qa.bidsxchange.com/1338.js"></script>' +
    "";

  const bottomFooterScript =
    "" +
    "<script>" +
    "window.googletag = window.googletag || { cmd: [] };" +
    "var ub_interstitialSlot;" +
    "googletag.cmd.push(function () {" +
    'ub_interstitialSlot = googletag.defineOutOfPageSlot("/22678428348/SDPL_Epaper_Interstitial",googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());' +
    "googletag.enableServices();});" +
    "googletag.cmd.push(function () {googletag.pubads().refresh([ub_interstitialSlot]);});" +
    "</script>" +
    "";

  const homePageScript2nd =
    "" +
    '<script type="text/javascript">' +
    "(function(){" +
    "var o='script'," +
    "s=top.document," +
    "a=s.createElement(o)," +
    "m=s.getElementsByTagName(o)[0]," +
    "d=new Date()," +
    'timestamp=""+d.getDate()+d.getMonth()+d.getHours();' +
    "a.async=1;" +
    "a.src='https://cdn4-hbs.affinitymatrix.com/hvrcnf/sandesh.com/'+ timestamp + '/index?t='+timestamp;" +
    "m.parentNode.insertBefore(a,m)" +
    "})();" +
    "</script>" +
    "";
  setTimeout(() => {
    setSport(sportLayout?.value);
  }, 200);

  const globalScript =
    "" +
    // '<script async src="https://cdn.unibots.in/genericcube/common/script.js"></script>'+
    // "<script>"+
    //   "window.unibotsDirectAds = window.unibotsDirectAds || { cmd: [] };"+
    //    "unibotsDirectAds.cmd.push('sandesh');"+
    // "</script>"+
    "";

  const homePageScript4th =
    "" +
    "<div id='div-gpt-ad-1666261240163-0'>" +
    "<script>" +
    "googletag.cmd.push(function() { googletag.display('div-gpt-ad-1666261240163-0'); });" +
    "</script>" +
    " <script>" +
    "window.googletag = window.googletag || {cmd: []};" +
    "googletag.cmd.push(function() {" +
    "googletag.defineSlot('/22678428348/Median_CanadaCampaign_1x1', [1, 1], 'div-gpt-ad-1666261240163-0').addService(googletag.pubads());" +
    "googletag.pubads().enableSingleRequest();" +
    " googletag.enableServices();" +
    "});" +
    "</script>" +
    "</div>" +
    "";

  //   const New_add_vertical = `
  //   <div id='div-gpt-ad-1739336906750-0'>
  //   <script>
  //   window.googletag = window.googletag || {cmd: []};
  //   googletag.cmd.push(function() {
  //     googletag.defineSlot('/22678428348/SDPL_HP_1x1_Vertice', [1, 1], 'div-gpt-ad-1739336906750-0').addService(googletag.pubads());
  //     googletag.pubads().enableSingleRequest();
  //     googletag.enableServices();
  //   });
  // </script>
  // <script>
  //     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1739336906750-0'); });
  //   </script>
  //   </div>
  //   `;

  const isEventPage = window.location.pathname === "/event";
  const status = window.location.pathname.includes("/status");
  const appstockmarket = window.location.pathname === "/app-stockmarket";
  const allEventsPage = window.location.pathname === "/all-events";
  const eventDetailPage = window.location.pathname.includes("/event-detail");
  const eventBookingPage = window.location.pathname.includes("/event-booking");
  const isWebStoryPage = window.location.pathname.startsWith("/webstory/");
  const is_search_content =
    window.location.pathname.startsWith("/search-content/");

  return (
    <>

      <div className="ad-section">
        <meta name="author" content="Sandesh News" />

        <div className="text-center">
          <HelperScript argSmall={187} argLarge={40} />
        </div>
      </div>
      <InjectScript key={Math.random()} script={taboolacontent} />
      <InjectScript script={globalScript} key={Math.random()} />
      {/* <InjectScript script={New_add_vertical} /> */}
      <Router onChange={routeChange}>
        <ScrollToTop />
        <Suspense fallback={<></>}>
          {!isEventPage &&
            !isWebStoryPage &&
            !appstockmarket &&
            !allEventsPage &&
            !eventDetailPage &&
            !eventBookingPage && <Topbar onDarkMode={onDarkMode} mode={mode} />}
          {window.location.href?.includes("/epaper") ? (
            <EpaperMenu />
          ) : (
            <>
              {!isEventPage &&
                !isWebStoryPage &&
                !appstockmarket &&
                !allEventsPage &&
                !eventDetailPage &&
                !eventBookingPage &&
                !status && <Menu />}
              {!isEventPage &&
                !appstockmarket &&
                !isWebStoryPage &&
                !allEventsPage &&
                !eventDetailPage &&
                !eventBookingPage &&
                !status && <MenuPage />}
              {window.location.href?.includes("/metro") ||
                window.location.href?.includes("/samagra") ||
                window.location.href?.includes("/video/")
                ? ""
                : url?.split("/")?.[4] &&
                !isEventPage &&
                !allEventsPage &&
                !eventDetailPage &&
                !isWebStoryPage &&
                !eventBookingPage &&
                !is_search_content &&
                !status && <BreadCrumb />}
            </>
          )}
          {/* <HelperScript argSmall={253} argLarge={0} /> */}
          {window.innerWidth < 991 ? (
            <div
              className="ad-section  ad-placeholder"
              style={{ width: "300px", height: "100px" }}
            >
              <InjectScript key={Math.random()} script={headerMobile} />
            </div>
          ) : (
            ""
          )}
          <ComscoreTracker />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />
            {/* <Route exact path="/stockmarket" element={<Bajaj />} /> */}
            <Route exact path="/ScrollPage" element={<ScrollPage />} />
            <Route exact path="/app-stockmarket" element={<BajajApp />} />
            <Route exact path="/event" element={<EventIndex />} />
            <Route exact path="/status/:slug" element={<Status />} />
            <Route exact path="for-you" element={<Foryou />} />
            <Route exact path="candidate-list" element={<CandidateList />} />



            <Route exact path="election-2026" element={<ElectionPage />} />
            <Route exact path="election-2021" element={<ElectionPage />} />
            <Route exact path="local-body-election-2026" element={<LocalBodyEle />} />
            <Route exact path="assembly-election" element={<AssemblyEle />} />
            <Route exact path="try" element={<IndiaMap />} />
            <Route exact path="election-detail" element={<ElectionDetailpage />} />
            <Route exact path="rashifal" element={<RashifalPage />} />
            <Route exact path="/webstories" element={<WebStoryAll />} />
            {[
              "/webstory/:path1",
              "/webstory/:path1/:path2",
              "/webstory/:path1/:path2/:path3",
              "/webstory/:path1/:path2/:path3/:path4",
              "/webstory/:path1/:path2/:path3/:path4/:path5",
              "/webstory/:path1/:path2/:path3/:path4/:path5/:path6",
              "/webstory/:path1/:path2/:path3/:path4/:path5/:path6/:path7",
            ].map((path) => (
              <Route path={path} element={<WebStoryPage />} />
            ))}
            <Route exact path="/all-events" element={<AllEvents />} />
            <Route exact path="/event-detail/:id" element={<EventDetails />} />
            <Route exact path="/event-booking/:id" element={<EventBooking />} />
            <Route exact path="/video/:url" element={<VideoCategoryPage />} />
            {/* <Route exact path="/login" element={<Login />} /> */}
            {/* <Route exact path="/world" element={<World />} /> */}
            <Route
              exact
              path="/gujarat/metro"
              element={<GujaratMetro type="location" />}
            />
            <Route
              exact
              path="/gujarat/samagra"
              element={<GujaratSamagra type="location" />}
            />
            <Route
              exact
              path="/ganesh-chaturthi/:url"
              element={<GaneshChaturthiPage type="category" />}
            />
            <Route exact path="/tag/:url" element={<Gujarat type="tag" />} />
            <Route
              exact
              path="/"
              element={<AssemblyElection type="category" />}
            />
            <Route
              exact
              path="/assembly-elections"
              element={<AssemblyElection type="category" />}
            />
            <Route exact path="/:url" element={<Gujarat type="category" />} />
            <Route exact path="/location" element={<Gujarat type="location" />}>
              <Route
                exact
                path=":country"
                element={<Gujarat type="location" />}
              >
                <Route
                  exact
                  path=":state"
                  element={<Gujarat type="location" />}
                >
                  <Route
                    exact
                    path=":city"
                    element={<Gujarat type="location" />}
                  />
                </Route>
              </Route>
            </Route>
            <Route exact path="/epaper" element={<Epaper />} />
            <Route exact path="/epaper/sub" element={<ClippedImage />} />
            <Route
              exact
              path="/epaper/:city"
              element={<EpaperCategoryNewsPerDate />}
            />
            <Route exact path="/video" element={<VideosComponent />} />
            <Route exact path="/videos" element={<VideosComponent />} />
            {/* <Route exact path="/:url" element={<VideosInnerComponent />} /> */}
            <Route exact path="/page/:id" element={<Pages />} />
            <Route
              exact
              path="/investor-relations"
              element={<PagesInvestorRelation />}
            />
            <Route exact path="/gallery" element={<GalleryComponent />} />
            <Route exact path="/page/rss" element={<Rss />} />
            <Route exact path="/page/sitemap" element={<Sitemap />} />
            {sport === "2" ? (
              <Route
                exact
                path="/t20-world-cup"
                element={<Sport type="category" />}
              />
            ) : (
              ""
            )}
            {/* <Route exact path="/gallery/inner/:url" element={<GalleryInnerComponents />} /> */}
            <Route exact path="/astrology" element={<AstrologyComponent />} />
            {/* <Route
              exact
              path="/astrology/:rashi"
              element={<AstrologyDetailpage />}
            /> */}
            <Route
              exact
              path="/astrology/:rashi/daily"
              element={<AstrologyDetailpage />}
            />
            <Route
              exact
              path="/astrology/:rashi/weekly"
              element={<AstrologyDetailpage />}
            />
            <Route
              exact
              path="/astrology/:rashi/yearly"
              element={<AstrologyDetailpage />}
            />
            <Route
              exact
              path="/astrology/:rashi/tarot"
              element={<AstrologyDetailpage />}
            />
            <Route
              exact
              path="/astrology/:rashi"
              element={<AstrologyDetailpage />}
            />
            <Route
              exact
              path="/astrology/:rashi"
              element={<AstrologyDetailpage />}
            />

            <Route exact path="/supplement" element={<Supplement />} />
            {/* <Route exact path="/astrology/inner" element={<AstrologyInner />} /> */}
            {/* <Route exact path="/location" element={<Location />} /> */}
            <Route exact path="/search" element={<SearchResult />} />
            <Route
              exact
              path="/search-content/:searchValue"
              element={<NewsSearch />}
            />
            {/* <Route exact path="/:searchValue" element={<NewsSearch />} /> */}
            {/* <Route exact path="/profile" element={<Profile />} /> */}
            {localStorage.getItem("access_token") && (
              <Route exact path="/profile" element={<Profile />} />
            )}
            <Route exact path="/maintenance" element={<Maintenance />} />
            {/* <Route path="/:url" element={<Post />} /> */}

            {[
              "/:path1",
              "/:path1/:path2",
              "/:path1/:path2/:path3",
              "/:path1/:path2/:path3/:path4",
              "/:path1/:path2/:path3/:path4/:path5",
              "/:path1/:path2/:path3/:path4/:path5/:path6",
              "/:path1/:path2/:path3/:path4/:path5/:path6/:path7",
            ].map((path) => (
              <Route path={path} element={<Post />} />
            ))}
          </Routes>
          <ScrollButton />
          {!isWebStoryPage && !appstockmarket && <Footer mode={mode} />}
          {/* <InjectScript script={allPage} /> */}
          {/* {window.location.pathname.includes('epaper') ? <InjectScript script={bottomFooterScript} /> : ''} */}
          {/* {window.location.pathname === "/" ? <><InjectScript script={homePageScript2nd} /><InjectScript script={homePageScript4th} /></>: ''} */}
          {window.location.pathname === "/" ? (
            <>
              <InjectScript script={homePageScript2nd} />
            </>
          ) : (
            ""
          )}
          {/* {!url?.includes('/epaper/sub') && <Footer mode={mode} />} */}
        </Suspense>
      </Router>
    </>
  );
}

export default App;
